/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY.
 * Generated by scripts/generate-slide-types.py.
 */

import baseSchema from '@digital-twins/slide-schemas/presets/base.schema.json';
import continuousDensitySchema from '@digital-twins/slide-schemas/presets/continuous-density.schema.json';
import coverSchema from '@digital-twins/slide-schemas/presets/cover.schema.json';
import evidenceMultiplesSchema from '@digital-twins/slide-schemas/presets/evidence-multiples.schema.json';
import evidencePairSchema from '@digital-twins/slide-schemas/presets/evidence-pair.schema.json';
import evidenceRailSchema from '@digital-twins/slide-schemas/presets/evidence-rail.schema.json';
import evidenceSingleSchema from '@digital-twins/slide-schemas/presets/evidence-single.schema.json';
import execSummarySchema from '@digital-twins/slide-schemas/presets/exec-summary.schema.json';
import matrixCategoricalBarsSchema from '@digital-twins/slide-schemas/presets/matrix-categorical-bars.schema.json';
import matrixRatingSchema from '@digital-twins/slide-schemas/presets/matrix-rating.schema.json';
import metricCalloutSchema from '@digital-twins/slide-schemas/presets/metric-callout.schema.json';
import multiSelectBarsSchema from '@digital-twins/slide-schemas/presets/multi-select-bars.schema.json';
import outroSchema from '@digital-twins/slide-schemas/presets/outro.schema.json';
import podiumSchema from '@digital-twins/slide-schemas/presets/podium.schema.json';
import priceSensitivitySchema from '@digital-twins/slide-schemas/presets/price-sensitivity.schema.json';
import quadrantMapSchema from '@digital-twins/slide-schemas/presets/quadrant-map.schema.json';
import qualAnalysisSchema from '@digital-twins/slide-schemas/presets/qual-analysis.schema.json';
import rankingSchema from '@digital-twins/slide-schemas/presets/ranking.schema.json';
import ratingLikertSchema from '@digital-twins/slide-schemas/presets/rating-likert.schema.json';
import recommendationsSchema from '@digital-twins/slide-schemas/presets/recommendations.schema.json';
import respondentFeatureSchema from '@digital-twins/slide-schemas/presets/respondent-feature.schema.json';
import singleSelectBarsSchema from '@digital-twins/slide-schemas/presets/single-select-bars.schema.json';
import plotChoiceBarsSchema from '@digital-twins/slide-schemas/plots/choice-bars.schema.json';
import plotCommonSchema from '@digital-twins/slide-schemas/plots/common.schema.json';
import plotDensityHistogramSchema from '@digital-twins/slide-schemas/plots/density-histogram.schema.json';
import plotDivergingLikertSchema from '@digital-twins/slide-schemas/plots/diverging-likert.schema.json';
import plotGroupedBarsSchema from '@digital-twins/slide-schemas/plots/grouped-bars.schema.json';
import plotHeatGridSchema from '@digital-twins/slide-schemas/plots/heat-grid.schema.json';
import plotKpiSchema from '@digital-twins/slide-schemas/plots/kpi.schema.json';
import plotPodiumSchema from '@digital-twins/slide-schemas/plots/podium.schema.json';
import plotPriceCurvesSchema from '@digital-twins/slide-schemas/plots/price-curves.schema.json';
import plotQuadrantSchema from '@digital-twins/slide-schemas/plots/quadrant.schema.json';
import plotQuoteListSchema from '@digital-twins/slide-schemas/plots/quote-list.schema.json';
import plotRadarSchema from '@digital-twins/slide-schemas/plots/radar.schema.json';
import plotRankingBarsSchema from '@digital-twins/slide-schemas/plots/ranking-bars.schema.json';
import plotShareDonutSchema from '@digital-twins/slide-schemas/plots/share-donut.schema.json';
import plotStacked100BarsSchema from '@digital-twins/slide-schemas/plots/stacked-100-bars.schema.json';

export interface SlideSchema {
  $id?: string;
  title?: string;
  description?: string;
  type?: string;
  properties?: Record<string, any>;
  required?: Array<string>;
  $defs?: Record<string, any>;
  allOf?: Array<any>;
  anyOf?: Array<any>;
  oneOf?: Array<any>;
  [key: string]: any;
}

export const SCHEMAS: Record<string, SlideSchema> = {
  'continuous-density': continuousDensitySchema as SlideSchema,
  'cover': coverSchema as SlideSchema,
  'evidence-multiples': evidenceMultiplesSchema as SlideSchema,
  'evidence-pair': evidencePairSchema as SlideSchema,
  'evidence-rail': evidenceRailSchema as SlideSchema,
  'evidence-single': evidenceSingleSchema as SlideSchema,
  'exec-summary': execSummarySchema as SlideSchema,
  'matrix-categorical-bars': matrixCategoricalBarsSchema as SlideSchema,
  'matrix-rating': matrixRatingSchema as SlideSchema,
  'metric-callout': metricCalloutSchema as SlideSchema,
  'multi-select-bars': multiSelectBarsSchema as SlideSchema,
  'outro': outroSchema as SlideSchema,
  'podium': podiumSchema as SlideSchema,
  'price-sensitivity': priceSensitivitySchema as SlideSchema,
  'quadrant-map': quadrantMapSchema as SlideSchema,
  'qual-analysis': qualAnalysisSchema as SlideSchema,
  'ranking': rankingSchema as SlideSchema,
  'rating-likert': ratingLikertSchema as SlideSchema,
  'recommendations': recommendationsSchema as SlideSchema,
  'respondent-feature': respondentFeatureSchema as SlideSchema,
  'single-select-bars': singleSelectBarsSchema as SlideSchema,
};

export const SHARED_SCHEMAS: Record<string, SlideSchema> = {
  'base': baseSchema as SlideSchema,
  'base.schema.json': baseSchema as SlideSchema,
  './base.schema.json': baseSchema as SlideSchema,
};

// The plot registry by file stem ('common' plus one per plot kind).
export const PLOT_SCHEMAS: Record<string, SlideSchema> = {
  'choice-bars': plotChoiceBarsSchema as SlideSchema,
  'common': plotCommonSchema as SlideSchema,
  'density-histogram': plotDensityHistogramSchema as SlideSchema,
  'diverging-likert': plotDivergingLikertSchema as SlideSchema,
  'grouped-bars': plotGroupedBarsSchema as SlideSchema,
  'heat-grid': plotHeatGridSchema as SlideSchema,
  'kpi': plotKpiSchema as SlideSchema,
  'podium': plotPodiumSchema as SlideSchema,
  'price-curves': plotPriceCurvesSchema as SlideSchema,
  'quadrant': plotQuadrantSchema as SlideSchema,
  'quote-list': plotQuoteListSchema as SlideSchema,
  'radar': plotRadarSchema as SlideSchema,
  'ranking-bars': plotRankingBarsSchema as SlideSchema,
  'share-donut': plotShareDonutSchema as SlideSchema,
  'stacked-100-bars': plotStacked100BarsSchema as SlideSchema,
};

export function listSchemaTypes(): Array<string> {
  return Object.keys(SCHEMAS).sort();
}
